import { Button } from '@tempmee/react';
import { TableData } from '../../../commonComponents/Table/TableData';

export const renderRow = (item, handleOnClick) => (
  <>
    <TableData text={item.officeName} />
    <TableData text={item.state} />
    <td>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <Button variant="secondary" size="xs" onClick={() => handleOnClick(item, 'contractor')}>
          Contractor
        </Button>
        <Button size="xs" onClick={() => handleOnClick(item, 'employee')}>
          Employee
        </Button>
      </div>
    </td>
  </>
);
